import * as React from "react";
import { connect } from "react-redux";
import { bindActionCreators, Dispatch } from "redux";
import { StoreModel } from "models/StoreModel";
import { LoginUserActions } from "redux/actions/LoginUserActions";
import { PageContentHeader } from "app/components/common/PageContentHeader";
import Translator from "app/components/common/Translator";

interface Props {
    moveHome: typeof LoginUserActions.moveToHome;
}

class DeleteSuccessComp extends React.Component<Props> {
    render() {
        return (
            <div className="c-page__content">
                <PageContentHeader text="Farewell!" />
                <div className="c-card">
                    <Translator text="Your account and all you data has been deleted! We hope to see you again sometimes!" />
                </div>
            </div>
        )
    }
}

function mapStateToProps(_state: StoreModel) {
    return {
    };
}
function mapDispatchToProps(dispatch: Dispatch) {
    return {
        moveHome: bindActionCreators(LoginUserActions.moveToHome, dispatch),
    };
}
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(DeleteSuccessComp);